export default __webpack_public_path__ + "static/media/blog-icon.a98cd78c.jpeg";